import Vue from 'vue'
import {
  Dialog,
  Tabbar,
  TabbarItem,
  Icon,
  Form,
  Field,
  Button,
  Toast,
  Uploader,
  Stepper,
  Popup,
  Slider,
  Rate,
  Step,
  Steps,
  Empty,
  Calendar,
  Picker,
  RadioGroup,
  Radio,
  CellGroup,
  Cell,
  Tab,
  Tabs,
  Checkbox,
  Loading,
  Search,
  DropdownMenu,
  DropdownItem,
  List,
  Sidebar,
  SidebarItem,
  ImagePreview
} from 'vant'

Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Icon)
Vue.use(Form)
Vue.use(Field)
Vue.use(Button)
Vue.use(Toast)
Vue.use(Uploader)
Vue.use(Stepper)
Vue.use(Popup)
Vue.use(Slider)
Vue.use(Rate)
Vue.use(Step)
Vue.use(Steps)
Vue.use(Empty)
Vue.use(Calendar)
Vue.use(Picker)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Tabs)
Vue.use(Tab)
Vue.use(Checkbox)
Vue.use(Loading)
Vue.use(Dialog)
Vue.use(Search)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(List)
Vue.use(Sidebar)
Vue.use(SidebarItem)

Vue.prototype.$toast = Toast
Vue.prototype.$dialog = Dialog
Vue.prototype.$imagePreview = ImagePreview
